<template>
  <div
    class="mixamag-bg-container"
    :style="{ background: mixaMagData.isnothomepage ? '#fff' : '#f0f0f0', textAlign: 'left' }"
  >
    <div class="container">
      <div class="row">
        <div
          v-if="mixaMagData.isnothomepage && mixaMagData.articles.length > 0"
          class="carousel-horzontal-line"
        ></div>
        <div class="bloc-mixa-mag-container">
          <h2 v-if="mixaMagData.articles.length > 0">{{ mixaMagData.title }}</h2>
          <h3
            v-if="mixaMagData.articles.length > 0"
            :class="mixaMagData.isnothomepage ? 'title-container' : ''"
          >
            {{ mixaMagData.subtitle }}
          </h3>
          <carousel
            :rotate-tag="{ __eventType: 'click' }"
            :auto-rotate="false"
            go-to-slide-text="Go to slide"
            pause-carousel-text="pause carousel"
            play-carousel-text="play carousel"
            previous-slide-text="previous slide"
            next-slide-text="next slide"
            :navigation-enabled="mixaMagData.articles.length > 3 ? true : false"
            :pagination-enabled="false"
            :isnothomepage="mixaMagData.isnothomepage"
            :per-page="1"
            :scroll-per-page="false"
            :per-page-custom="perPageCustom"
          >
            <slide
              v-for="slider in mixaMagData.articles"
              :key="slider.title"
              class="col-sm-12 col-md-4"
            >
              <h4>{{ slider.title }}</h4>
              <div :style="{ border: mixaMagData.isnothomepage ? '1px solid #f0f0f0' : '' }">
                <div :class="{ 'is-video': slider.hasvideo }">
                  <img :alt="slider.alt" :src="slider.image" @click="navigateTo(slider.url)" />
                </div>
                <div class="text-container">
                  <p v-shave="{ height: 100 }">{{ slider.description }}</p>
                  <div
                    v-show="slider.url != ''"
                    class="discover-btn"
                    @click="
                      decoverdatalayer(
                        slider.url,
                        mixaMagData.title,
                        mixaMagData.ctabuttontext,
                        mixaMagData.subtitle,
                      )
                    "
                  >
                    <a :href="slider.url" role="button">
                      <strong>{{ mixaMagData.ctabuttontext }}</strong>
                    </a>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
          <div class="related-artical">
            <p @click="navigateTo(mixaMagData.seeallLinkurl)">{{ mixaMagData.seeallinktext }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bloc-mixa-mag',
  props: {
    mixaMagData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      perPageCustom: [],
      windowWidth: 0,
      rightColumn: '',
    };
  },
  mounted() {
    if (this.mixaMagData.isnothomepage && !this.mixaMagData.isarticledetailpage)
      document.getElementsByClassName('carousel-horzontal-line')[0].style.display = 'none';
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });
    this.rightColumn = document.getElementById('desktop-article-right-column');
    if (this.mixaMagData.isarticledetailpage) {
      var carouselLines = document.getElementsByClassName('carousel-horzontal-line');
      if (carouselLines.length !== 0) {
        var firstCarouselLine = carouselLines[0];
        firstCarouselLine.style.marginTop = '9px';
        firstCarouselLine.style.marginBottom = '25px';
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
  methods: {
    navigateTo(url) {
      window.location.href = url;
    },
    decoverdatalayer(urls, tittle, buttontext, subtitle) {
      var newtitle = subtitle;
      if (tittle) {
        newtitle = tittle;
      }
      dataLayer.push({
        event: 'uaevent',
        eventCategory: this.mixaMagData.pagecategory,
        eventAction: `select::${newtitle}`,
        eventLabel: `${buttontext}::${urls}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: newtitle,
        cta_name: buttontext,
        link_url: urls,
      });
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth <= 768) {
        this.perPageCustom = [[0, 1]];
      } else {
        this.perPageCustom = [[0, 3]];
      }
      if (window.innerWidth <= 768 && this.rightColumn !== null)
        this.rightColumn.style.display = 'none';
      else if (this.rightColumn !== null) {
        this.rightColumn.style.display = 'block';
      }
    },
  },
};
</script>
